@if (isLoading) {
  <div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
}
@if (!error) {
  <div  class="canvas-container">
    <div class="canvas-block" >
      <canvas baseChart height="240px;" width="100%"
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="barChartLegend"
        [type]="barChartType">
      </canvas>
    </div>
  </div>
}
@if (error) {
  <p class="chartErrorText">{{error}}</p>
}